import { render, staticRenderFns } from "./IconBar.vue?vue&type=template&id=3cd8b866&scoped=true&"
import script from "./IconBar.vue?vue&type=script&lang=ts&"
export * from "./IconBar.vue?vue&type=script&lang=ts&"
import style0 from "./IconBar.vue?vue&type=style&index=0&id=3cd8b866&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd8b866",
  null
  
)

export default component.exports